import styled from 'styled-components'

const Input = styled.input`
  border: none;
  border-radius: 4px;
  background: #1F1F29;
  padding: 12px 16px;
  color: white;
`

export default Input;